/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Section_ContractInputs */

const en_clients_section_contract = /** @type {(inputs: Clients_Section_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contract`)
};

const pt_br2_clients_section_contract = /** @type {(inputs: Clients_Section_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrato`)
};

/**
* | output |
* | --- |
* | "Contract" |
*
* @param {Clients_Section_ContractInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_section_contract = /** @type {((inputs?: Clients_Section_ContractInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Section_ContractInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_section_contract(inputs)
	return pt_br2_clients_section_contract(inputs)
});